<template>
  <div
    class="tech-chart-legend-container"
  >
    <div class="tech-chart-legend-row">
      <div
        :style="{ backgroundColor: '#66D383' }"
        class="tech-chart-legend-symbol"
      />
      <div class="tech-chart-item-symbol">
        Verified Installs
      </div>
    </div>
    <div class="tech-chart-legend-row">
      <div
        :style="{ backgroundColor: '#397151' }"
        class="tech-chart-legend-symbol"
      />
      <div class="tech-chart-item-symbol">
        Hardware Installs
      </div>
    </div>
    <div class="tech-chart-legend-row">
      <div
        :style="{ backgroundColor: '#2A448E' }"
        class="tech-chart-legend-symbol"
      />
      <div class="tech-chart-item-symbol">
        Member Purchases
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CumulativeBarChartLegend',
};
</script>

<style lang="scss">

.tech-chart-legend-container {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    // border: 1px solid white;
    border-radius: 8px;
    background-color: #0B0F1E;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .tech-chart-legend-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      .tech-chart-legend-symbol {
        border: 1px solid white;
        border-radius: 10px;
        width: 30px;
        height: 25px;
        margin:0 10px;
      }
      .tech-chart-item-symbol {
        color: $WHITE;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
</style>
